import React, { useState } from 'react';
import { useT } from '../../i18n/useT';
import './HowItWorks.css';

export default function HowItWorks() {
  const [activeStep, setActiveStep] = useState(0);
  const t = useT();
  const hiw = t.howItWorks;
  const STEPS = hiw.steps;

  return (
    <section className="how-it-works section" aria-labelledby="hiw-heading">
      <div className="how-it-works__bg" aria-hidden="true" />
      <div className="container">
        <div className="section-header" style={{ color: 'white' }}>
          <div className="badge" style={{ background: 'rgba(255,255,255,0.15)', color: 'white', borderColor: 'rgba(255,255,255,0.2)' }}>
            {hiw.badge}
          </div>
          <h2 id="hiw-heading" style={{ color: 'white', marginTop: 'var(--space-4)', whiteSpace: 'pre-line' }}>
            {hiw.headline}
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.7)' }}>{hiw.sub}</p>
        </div>

        <div className="hiw__layout">
          <div className="hiw__steps">
            {STEPS.map((step, i) => (
              <button
                key={i}
                className={`hiw__step ${activeStep === i ? 'hiw__step--active' : ''}`}
                onClick={() => setActiveStep(i)}
                aria-pressed={activeStep === i}
              >
                <div className="hiw__step-number">{step.step}</div>
                <div className="hiw__step-content">
                  <h3 className="hiw__step-title">{step.title}</h3>
                  <p className="hiw__step-desc">{step.description}</p>
                </div>
              </button>
            ))}
          </div>

          <div className="hiw__visual">
            <div className="hiw__visual-card">
              <div className="hiw__visual-number">{STEPS[activeStep].step}</div>
              <h3 className="hiw__visual-title">{STEPS[activeStep].title}</h3>
              <p className="hiw__visual-desc">{STEPS[activeStep].description}</p>
              <div className="hiw__visual-detail">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.2"/>
                  <path d="M8 5v3l2 2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
                </svg>
                {STEPS[activeStep].detail}
              </div>
              <div className="hiw__visual-progress">
                {STEPS.map((_, i) => (
                  <div
                    key={i}
                    className={`hiw__visual-dot ${activeStep === i ? 'hiw__visual-dot--active' : ''}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
